import { db } from '../../../firebase';
import {
  FETCH_COMPLETED_CHITTIES_STARTED,
  FETCH_COMPLETED_CHITTIES_COMPLETED,
  FETCH_COMPLETED_CHITTIES_ERROR
} from '../../actionTypes/chittiesActionTypes';

export const fetchCompletedChittiesStart = () => ({
  type: FETCH_COMPLETED_CHITTIES_STARTED
});
export const fetchCompletedChittiesSuccess = (data) => ({
  type: FETCH_COMPLETED_CHITTIES_COMPLETED,
  payLoad: data
});
export const fetchCompletedChittiesFailure = () => ({
  type: FETCH_COMPLETED_CHITTIES_ERROR
});

export const fetchChittiesByAuctions = () => {
  return (dispatch) => {
    dispatch(fetchCompletedChittiesStart());
    let auctions = 20;
    db.getCompletedChitties(auctions).then((snapshot) => {
      let chitties = {};
      if (snapshot.val()) {
        let data = snapshot.val();
        Object.keys(data).map((key) => {
          if (data[key].status === 'active') {
            chitties[key] = data[key];
          }
        });
      }
      dispatch(fetchCompletedChittiesSuccess(chitties));
    });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/ChittiesActions/fetchChittiesByAuctions.js